import { Subscribe } from '@react-rxjs/core';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Fallback } from '../../../components/Fallback';
import { CloseButton } from '../../../components/Modal/CloseButton';
import { HeaderSlot, ShellContent } from '../../../components/Shell';
import { HideBotMenu } from '../../../components/Shell/HideBotMenu';
import {
  refreshLogbookList,
  retryLogbookDownload,
  useDownloadLogbookreport,
  useLogbookReportListItem,
} from '../../../services/logbook';
import styles from './DownloadLogbook.module.css';
import { Navigate, useNavigate } from 'react-router-dom';
import { PlaceCenter } from '../../../components/PlaceCenter';
import { Spinner } from '../../../components/Spinner';
import { Button } from '../../../components/Button';

export const DownloadLogbook: FC = () => {
  const navigate = useNavigate();
  const report = useLogbookReportListItem();
  const signed = report?.status === 'SIGNED';
  const running = signed && !('renderedFilename' in report);

  useDownloadLogbookreport();

  if (!report) {
    return <Navigate to="/logbook" />;
  }

  return (
    <ShellContent full>
      <div className={styles.root}>
        <HeaderSlot slot="title">{report.day}</HeaderSlot>
        <PlaceCenter>
          {!running ? (
            <div className={styles.center}>
              <FormattedMessage id="Logbook.Report.Downloading" tagName="div" />
              <Button variant="text" onClick={retryLogbookDownload}>
                <FormattedMessage id="TryAgain" />
              </Button>
            </div>
          ) : (
            <div className={styles.center}>
              <FormattedMessage id="Logbook.Report.Generating" tagName="div" />
              <Spinner />
              <Button variant="text" onClick={refreshLogbookList}>
                <FormattedMessage id="TryAgain" />
              </Button>
            </div>
          )}
        </PlaceCenter>

        <HeaderSlot slot="rightContent">
          <CloseButton onClick={() => navigate('/logbook')} />
        </HeaderSlot>
        <HideBotMenu />
      </div>
    </ShellContent>
  );
};

export const SubscribedDownloadLogbook = () => (
  <Subscribe fallback={<Fallback />}>
    <DownloadLogbook />
  </Subscribe>
);
